import { JOVENES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    ventana_filtros: false, 
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case JOVENES.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case JOVENES.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case JOVENES.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( joven => joven._id !== payload.id )
            };

        case JOVENES.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        default:
            return state;
    }
}